import { Button, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PrintIcon from '@mui/icons-material/Print';
import { useTheme } from '@mui/system';
import { NAVIGATION_NS } from '../../i18n/navigation';
import { useCallback } from 'react';

interface PrintButtonProps {
  onHandlePrint: () => void;
  disabled?: boolean;
  isVisible?: boolean;
}

export const PrintButton = ({ onHandlePrint, disabled, isVisible = false }: PrintButtonProps) => {

  const { t } = useTranslation([NAVIGATION_NS]);
  const { palette, breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down(700));

  const handlePrint = useCallback(
    (event: React.SyntheticEvent) => {
      event.stopPropagation();
      onHandlePrint();
    },
    [onHandlePrint],
  );

  if (!isVisible) {
    return <></>;
  }

  return (
    // A disabled MUI button has pointer-events: none, so a click would fall through to the
    // accordion header and toggle it. The wrapping span swallows the click in that case.
    <span onClick={(e) => e.stopPropagation()} style={{ display: 'inline-flex' }}>
      <Button
        sx={{
          ml: '16px',
          borderColor: palette.secondary.border,
          bgColor: palette.secondary.main,
          color: palette.text.primary,
          maxHeight: '36px',
          minWidth: isMobile ? '20px' : '72px',
          marginLeft: isMobile ? 0 : '8px',
          '> span': {
            marginRight: isMobile ? 0 : '8px',
          },
        }}
        variant="outlined"
        color="secondary"
        startIcon={<PrintIcon />}
        disabled={disabled}
        onClick={handlePrint}
      >
        {isMobile ? null : (
          <Typography sx={{ 'white-space': 'nowrap' }}>{t('navigation:print')}</Typography>
        )}
      </Button>
    </span>
  );
};
